import React from 'react'
import {Link, Icon} from '../'
import ClassNames from 'classnames';
import { logout} from '../../api';
import AppState from '../../state/AppState';
import * as Paths from '../../constants/Paths';
import { Menu, MenuItem, Popover, Position } from "@blueprintjs/core";

class NavbarMinimal extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { className, AppState, history } = this.props;

    const ProfileMenu = (
      <Menu className="">
        <MenuItem text="Settings" iconName="cog" onClick={() => history.push(Paths.DB_USER_SETTINGS)}/>
        <MenuItem text="Logout" iconName="log-out" onClick={() => this.onLogout()}/>
      </Menu>
    );

    var classNames = ClassNames("NavbarMinimal grid-row v-align", className);

    return (
      <div className={classNames}>
        <Link href={Paths.HOME} className="grid-row v-align logo">
          <Icon name="logo1"/>
          <div className="logo-text">
            SnapTest
          </div>
        </Link>
        {AppState.user.email && (
          <Link to={Paths.DB_USER_HOME} className="btn-primary">Accounts</Link>
        )}
        <div className="grid-item login grid-row r-align">
          {AppState.user.email ? (
            <Popover content={ProfileMenu} position={Position.BOTTOM_RIGHT}>
              <button type="button" className="pt-button pt-minimal">
                {AppState.user.email}
              </button>
            </Popover>
          ) : (
            <Link href={Paths.LOGIN}>Login</Link>
          )}
        </div>
      </div>
    )
  }

  onLogout() {
    logout()
      .then(() => {
        AppState.setUser({});
      })
  }

}

export default AppState.connect(React, NavbarMinimal);



// WEBPACK FOOTER //
// ./src/components/marketing/NavbarMinimal.js